module.exports = __webpack_public_path__ + "static/media/slide02_image.e0f78773.png";